const HOME = "/";
const STAFF = "/staff";
const NEWS = "/news"
const STRUCTURE = "/structure"
const DEPARTMENTS = "/departments"
const DEPARTMENT = "/department/:departmentId"
const OFFICE = "/office/:officeId"
const NEWS_ITEM = "/news/:newsId"
const ADMISSION_SCHEDULE = "/admission-schedule"
const VACANCIES = '/vacancies'
const ADMINISTRATION = '/administration'
const CONTACTS = '/contacts'
const PUBLIC_INFORMATION = '/public-info'
const PUBLIC_INFORMATION_ITEM = '/public-info/:publicInfoId'
const TENDER_PROCUREMENTS = 'tender-procurements'
const GENERAL_INFORMATION = '/general-info'
const GENERAL_INFORMATION_ITEM = '/general-info/:generalInfoId'
const ABOUT = '/about'
const ABOUT_ITEM = "/about/:aboutId"
const OVERSIGHT_COMMITTEE = '/oversight-committee'
const OVERSIGHT_COMMITTEE_ITEM = '/oversight-committee/:id'
const SURGERY_REQUESTS = 'surgery-requests'
const SURGERY_SCHEDULE = 'surgery-schedule'


export {
  HOME,
  STAFF,
  NEWS,
  STRUCTURE,
  DEPARTMENTS,
  DEPARTMENT,
  OFFICE,
  NEWS_ITEM,
  ADMISSION_SCHEDULE,
  VACANCIES,
  ADMINISTRATION,
  CONTACTS,
  PUBLIC_INFORMATION,
  PUBLIC_INFORMATION_ITEM,
  TENDER_PROCUREMENTS,
  GENERAL_INFORMATION,
  GENERAL_INFORMATION_ITEM,
  ABOUT,
  ABOUT_ITEM,
  OVERSIGHT_COMMITTEE,
  OVERSIGHT_COMMITTEE_ITEM,
  SURGERY_REQUESTS,
  SURGERY_SCHEDULE,
};
